//#region Imports
import React, { useEffect } from 'react';
import { View, Text, ImageBackground, Image, TouchableOpacity, Platform } from 'react-native';
import { DrawerContentScrollView, DrawerItemList, } from '@react-navigation/drawer';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomLabel from '../CustomLabel/CustomLabel';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@react-navigation/native';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useAccountContext } from '../../hooks/useAccountContext';
import CustomAlert from '../CustomAlert/CustomAlert';
import { DEFAULTPROFILE } from '../../img/DefaultProfile';
import Swal from 'sweetalert2';
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from "react-native-safe-area-context";
//#endregion

const CustomDrawer = (props) => {

    //#region Function Definitions
    const { account } = useAccountContext();
    const { t } = useTranslation();
    const { colors } = useTheme()
    const { dispatch } = useAuthContext();
    const navigation = useNavigation();
    const insets = useSafeAreaInsets();
    //#endregion
    const handleLogout = () => {

        if (Platform.OS === 'web') {
            //* Note: below styles do not seem to be working. Maybe investigate?
            Swal.fire({
                title: `<text style="font-family:'Roboto-Medium', font-size:16px">Are you sure you want to sign out?</text>`,
                icon: "warning",
                showCancelButton: true,
                reverseButtons: true,
                cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                cancelButtonColor: '#d3d3d3',
                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Sign Out</text>`,
                confirmButtonColor: '#A0A2FF',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch({ type: 'LOGOUT' });
                };
            });
        } else {
            CustomAlert('Are you sure you want to sign out?', '',
                [
                    {
                        text: 'Cancel',
                        style: 'cancel',
                    },
                    {
                        text: 'Sign Out',
                        onPress: () => dispatch({ type: 'LOGOUT' })
                    },
                ],
                { cancelable: true }
            );
        };
    };


    return (
        < View style={{ flex: 1 }}>
            {Platform.OS !== 'web' && (
                <DrawerContentScrollView
                    {...props}
                    contentContainerStyle={{
                        backgroundColor: colors.background_header,
                        paddingTop: 0
                    }}
                >
                    {Platform.OS !== 'web' && <ImageBackground
                        style={{ padding: 20 }}>
                        {account !== null ? <Image
                            style={{
                                width: 80,
                                height: 80,
                                marginTop: '3%',
                                borderRadius: 100,
                                borderWidth: 1,
                                alignSelf: 'flex-start',
                            }}
                            source={{ uri: `data:image/png;base64,${account.photograph === '' || account.photograph === undefined ? DEFAULTPROFILE : account.photograph}` }}
                        /> : null}
                        <CustomLabel
                            value={account === null ? 'loading' : account.name}
                            type='MINORTITLE_NOMARGIN'
                        />
                        <CustomLabel
                            value={account === null ? 'loading' : account.seniority}
                            type='MINORTITLE_NOMARGIN'
                        />
                    </ImageBackground>}
                    <View style={{ flex: 1, backgroundColor: '#fff', paddingTop: 10 }}>
                        <DrawerItemList {...props} />
                    </View>
                </DrawerContentScrollView>)}
            <View style={{ padding: 20, borderTopWidth: 1, borderTopColor: colors.border_card ?? '#ccc', backgroundColor: colors.background_header, paddingBottom: Math.max(insets.bottom + 24, 40), }}>
                {Platform.OS !== 'web' && (
                    <>
                        <TouchableOpacity onPress={() => { props.navigation.navigate('MyAccountScreen') }} style={{ paddingVertical: 15 }}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Image style={{
                                    width: 30,
                                    height: 30,
                                    flexDirection: 'row',
                                    borderRadius: 100,
                                    borderWidth: 1,
                                    aligItem: 'center',
                                    right: 5
                                }} source={{ uri: `data:image/png;base64,${account === null ? DEFAULTPROFILE : account.photograph === '' || account.photograph === undefined ? DEFAULTPROFILE : account.photograph}` }}>
                                </Image>
                                <Text style={{ color: colors.text_primary, marginLeft: 5 }}>
                                    {t('My Profile')}
                                </Text>
                            </View>
                        </TouchableOpacity>

                        <TouchableOpacity onPress={() => { props.navigation.navigate('SettingsScreen') }} style={{ paddingVertical: 15 }}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Ionicons name="language-outline" size={22} color={colors.text_primary}/>
                                <Text
                                    style={{
                                        fontSize: 15,
                                        marginLeft: 5,
                                        color: colors.text_primary,
                                    }}>
                                    {t('navigate:settings')}
                                </Text>
                            </View>
                        </TouchableOpacity>
                        <TouchableOpacity style={{ paddingVertical: 15 }}
                            onPress={handleLogout}
                        >
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <Ionicons name="exit-outline" size={22} color={colors.text_primary} />
                                <Text style={{ marginLeft: 5, color: colors.text_primary }}>Sign Out</Text>
                            </View>
                        </TouchableOpacity>
                    </>

                )}
            </View>

        </View>

    );

};

export default CustomDrawer; 
